"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInfo = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _UserAvatar = require("../../../elements/user-avatar/UserAvatar");
var _userInfoModule = _interopRequireDefault(require("./user-info.module.scss"));
var UserInfo = function UserInfo(_ref) {
  var name = _ref.name,
    surname = _ref.surname,
    className = _ref.className,
    description = _ref.description,
    infoClassName = _ref.infoClassName;
  var fullName = "".concat(name, " ").concat(surname);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_userInfoModule.default['user-info'], className)
  }, /*#__PURE__*/_react.default.createElement(_UserAvatar.UserAvatar, {
    fullName: fullName
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_userInfoModule.default['user-info__info'], infoClassName, (0, _defineProperty2.default)({}, _userInfoModule.default['user-info__info--with-description'], description !== undefined))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_userInfoModule.default['user-info__full-name'], (0, _defineProperty2.default)({}, _userInfoModule.default['user-info__full-name--with-description'], description !== undefined)),
    title: fullName
  }, fullName), description && /*#__PURE__*/_react.default.createElement("span", {
    className: _userInfoModule.default['user-info__description'],
    title: typeof description === 'string' ? description : ''
  }, description)));
};
exports.UserInfo = UserInfo;